// extracted by mini-css-extract-plugin
module.exports =  {"header":"vlzpWoFu0NjijXtBj6ZS","logoContainer":"ebrY80pZM4ZtVz2r7Msy","title":"RFa96IJua4c00gS4mlaD","userContainer":"eTiFLIlz0zGspCt1PPeb"};